import LoveStoriesPage, { getServerSideProps } from 'pages/[lang]/love-stories';

export default LoveStoriesPage;

export { getServerSideProps };
